import { connect } from 'react-redux'
import ClaimsView from '../components/ClaimsView'
import { getSites } from '../../../store/sites'
import { getPrescribers } from '../../../store/prescribers'
import { getClaimsJobs } from '../../../store/tooling'

const mapDispatchToProps = {
  getSites,
  getPrescribers,
  getClaimsJobs
}

const mapStateToProps = (state) => {
  return {
    sites: state.sites.sites,
    ui: state.ui,
    prescribers: state.prescribers.prescribers,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsView)



// WEBPACK FOOTER //
// ./src/routes/Claims/containers/ClaimsContainer.jsx